module.exports = __webpack_public_path__ + "static/media/accordion-arrow-down.ac11600b.svg";